import { createIcon } from '@chakra-ui/icons';

export const FacebookRound = createIcon({
  displayName: 'FacebookRound',
  viewBox: '0 0 20 21',
  path: [
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1907_18694)">
        <path
          d="M20 10.5599C19.9998 8.64888 19.452 6.77796 18.4215 5.16861C17.391 3.55926 15.921 2.27888 14.1854 1.47905C12.4498 0.679223 10.5214 0.393443 8.62847 0.655543C6.73552 0.917643 4.95732 1.71665 3.50437 2.95796C2.05142 4.19928 0.984574 5.83092 0.430132 7.65973C-0.12431 9.48853 -0.143127 11.4379 0.375907 13.2771C0.894941 15.1162 1.93009 16.7682 3.35881 18.0373C4.78752 19.3064 6.54997 20.1396 8.4375 20.4382V13.4507H5.89833V10.5599H8.4375V8.35655C8.4375 5.85072 9.93083 4.46572 12.2142 4.46572C12.9643 4.47648 13.7126 4.54165 14.4533 4.66072V7.12238H13.1917C12.8119 7.07197 12.4276 7.17445 12.1233 7.40729C11.8191 7.64013 11.6197 7.98427 11.5692 8.36405C11.5549 8.4704 11.5526 8.57803 11.5625 8.68488V10.5599H14.3333L13.89 13.4507H11.5567V20.4382C13.91 20.0674 16.0537 18.8685 17.6016 17.0575C19.1495 15.2465 20.0001 12.9423 20 10.5599Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1907_18694">
          <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>,
  ],
});
